<template>
  <div class="row">
    <div class="minor__title dampCourse__title"
         :class="{'modal__title': isInModal}">
      Выберите материал гидроизоляции
      <button v-if="isInModal"
              class="modal__title-btn"
              @click="close">
        <img src="@/assets/img/close-mini.svg" alt="❌">
      </button>
    </div>
    <div class="dampCourse__filter">
      <label for="category-all"
             class="dampCourse__filter-item"
             :class="{'active': pickedCategory === ''}">
        <input type="radio"
               value=""
               v-model="pickedCategory"
               id="category-all">
        <span class="name">Все материалы</span>
      </label>
      <label :for="`category-${category.id}`"
             v-for="category in categories"
             :key="category.id"
             :class="{'active': pickedCategory === category.id}"
             class="dampCourse__filter-item">
        <input type="radio"
               :value="category.id"
               v-model="pickedCategory"
               :id="`category-${category.id}`">
        <span class="name">{{category.name}}</span>
      </label>
    </div>
    <div class="dampCourse__materials">
      <div class="dampCourse__materials-item"
           :class="{'active' : material.id === item.id, 'shadow': isInModal}"
           v-for="item in filteredCurrentMaterialsByCategory"
           :key="item.id">
        <label :for="`material-${item.id}`" class="dampCourse__materials-item--label">
          <input type="radio"
                 :value="item.id"
                 :id="`material-${item.id}`"
                 v-model="material.id"
                 @change="updateSectorMaterial">
          <span class="dampCourse__materials-item--img">
            <img :src="item.src" :alt="item.name">
          </span>
          <span class="dampCourse__materials-item--name">
            {{item.name}}
            <label :for="`info-material-${item.id}`" class="showInfo-btn">
              <input type="radio"
                     v-model="showInfo"
                     :id="`info-material-${item.id}`"
                     :value="item.id">
              <svg width="20"
                   height="20"
                   viewBox="0 0 20 20"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path class="circle" d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0
                10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#D6D6D6"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8 4.2666C10.4 4.2666 10.0666
                4.39993 9.7333 4.6666C9.46663 4.93327 9.3333 5.19993 9.3333 5.59993C9.3333 5.99993
                9.46663 6.2666 9.79997 6.53327C10.0666 6.79994 10.4666 6.93327 10.8666
                6.93327C11.2666 6.93327 11.6 6.79994 11.9333 6.53327C12.2 6.2666 12.3333 5.93327
                12.3333 5.59993C12.3333 5.19993 12.2 4.93327 11.9333 4.6666C11.5333 4.39993
                11.2 4.2666 10.8 4.2666ZM11.2 14.7333C10.8666 14.7333 10.6666 14.6666 10.5333
                14.5999C10.4 14.4666 10.3333 14.3333 10.3333 13.9999C10.3333 13.8666 10.3333 13.7333
                10.4 13.5333C10.4666 13.3333 10.4666 13.1333 10.5333 12.9333L11.1333
                10.7999C11.2 10.5999 11.2666 10.3999 11.2666 10.1333C11.2666 9.8666 11.3333 9.73327
                11.3333 9.6666C11.3333 9.19994 11.2 8.8666 10.8666 8.59993C10.5333 8.33327 10.0666
                8.19993 9.46663 8.19993C9.1333 8.19993 8.79997 8.2666 8.39997 8.39994C7.99997
                8.53327 7.66663 8.6666 7.26663 8.79993L7.1333 9.4666C7.26663 9.39993 7.39997
                9.39993 7.5333 9.33327C7.7333 9.2666 7.86663 9.2666 7.99997 9.2666C8.3333 9.2666
                8.5333 9.33327 8.66663 9.39994C8.79997 9.53327 8.86663 9.6666 8.86663
                9.99994C8.86663 10.1333 8.86663 10.3333 8.79997 10.4666C8.7333 10.6666 8.7333
                10.8666 8.66663 11.0666L7.99997 13.1333C7.9333 13.3333 7.9333 13.5333 7.86663
                13.7333C7.86663 13.9333 7.79997 14.0666 7.79997 14.2666C7.79997 14.7333 7.9333
                15.0666 8.26663 15.3333C8.59997 15.5999 9.06663 15.7333 9.66663 15.7333C10.0666
                15.7333 10.4 15.6666 10.6666 15.5999C10.9333 15.5333 11.3333 15.3333 11.8666
                15.1333L12 14.4666C11.9333 14.5333 11.8 14.5333 11.6 14.5999C11.5333 14.6666
                11.3333 14.7333 11.2 14.7333Z" fill="white"></path>
              </svg>
            </label>
          </span>
        </label>
        <div class="info__overlay" v-if="showInfo === item.id" @click="showInfo = ''">
          <div class="info">
            <button class="close" @click="showInfo = ''">
              <img src="@/assets/img/close-mini.svg" alt="❌">
            </button>
            <div class="info__title">{{item.name}}</div>
            <div class="info__text">толщина, мм <br><b>{{item.thickness}}</b></div>
            <div class="info__text">ширина рулонов, м <br>
              <div class="info__text-roll">
                <b v-for="i in item.rollWidth.length"
                   :class="{'divider': i < item.rollWidth.length}"
                   :key="i">
                  {{ item.rollWidth[i-1] }}
                </b>
              </div>
            </div>
            <span class="info__text">Сопротивление раздиру, Н <br><b>{{item.resistance}}</b></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapState, mapMutations } from 'vuex';

export default {
  props: {
    isInModal: Boolean,
  },
  data() {
    return {
      pickedCategory: '',
      showInfo: '',
    };
  },
  components: {
  },
  methods: {
    ...mapMutations({
      UPDATE_SECTOR_MATERIAL_PARAM: 'UPDATE_SECTOR_MATERIAL_PARAM',
      CLEAR_SECTOR_MATERIAL_SIZE_PARAMS: 'CLEAR_SECTOR_MATERIAL_SIZE_PARAMS',
    }),
    updateSectorMaterial() {
      if (this.isClearNeed) {
        this.CLEAR_SECTOR_MATERIAL_SIZE_PARAMS(this.sectorId);
      }
      if (this.isInModal) {
        this.UPDATE_SECTOR_MATERIAL_PARAM({
          id: this.sectorId,
          param: 'id',
          val: this.material.id,
        });
        this.$emit('closeModal');
        this.$emit('runPost');
      } this.UPDATE_SECTOR_MATERIAL_PARAM({
        id: this.sectorId,
        param: 'id',
        val: this.material.id,
      });
    },
    close() {
      this.$emit('closeModal');
    },
  },
  watch: {
    showInfo() {
      if (!this.isInModal) {
        if (this.showInfo) {
          this.$root.offBodyScroll();
        } else {
          this.$root.onBodyScroll();
        }
      }
    },
  },
  computed: {
    ...mapState({
      allMaterials: state => state.materials,
      categories: state => state.categories,
      mounting: state => state.mounting,
    }),
    sectorId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    sectorFromState() {
      return this.$store.getters.getSector(this.sectorId);
    },
    material() {
      return this.sectorFromState.material;
    },
    filteredAllMaterialsByMounting() {
      return this.allMaterials.filter(material => material.mounting.match(this.material.mounting));
    },
    filteredCurrentMaterialsByCategory() {
      if (this.pickedCategory) {
        return this.filteredAllMaterialsByMounting.filter(
          material => material.category === this.pickedCategory,
        );
      } return this.filteredAllMaterialsByMounting;
    },
    isClearNeed() {
      return this.sectorFromState.material.size.C !== ''
        || this.sectorFromState.material.size.D !== ''
        || this.sectorFromState.material.size.E !== '';
    },
  },
};
</script>
<style lang="sass" scoped>
  .dampCourse
    &__title
      +media((padding: (320: rem(48) rem(24) rem(30), 992: rem(82) 0 rem(21))))
      &.modal__title
        padding: rem(34) 0
        width: 100%
        display: flex
        flex-direction: row
        align-items: center
        justify-content: space-between
        +media((padding: (320: rem(24), 992: rem(34) 0)))
    &__filter
      display: flex
      flex-direction: row
      align-items: center
      max-width: 100%
      width: 100%
      position: relative
      +media((padding: (320: 0 rem(24) 0, 992: 0 0 rem(34))))
      &:after
        height: rem(1)
        width: calc(100% - 48px)
        background: $grey
        content: ""
        position: absolute
        left: rem(24)
        bottom: rem(1)
        +media((display: (320: block, 768: none)))
      &-item
        font-style: normal
        font-weight: bold
        color: #5C5C5C
        transition: .5s
        cursor: pointer
        position: relative
        text-align: left
        height: 100%
        +media((max-width: (320: rem(100), 768: unset)))
        +media((padding: (320: 0 0 rem(10), 768: rem(21) 0 rem(35))))
        +media((font-size: (320: rem(12), 768: rem(14))))
        +media((line-height: (320: rem(18), 768: rem(17))))
        +media((margin-right: (320: rem(20), 768: rem(30))))
        .name
          height: 100%
          position: relative
          +media((padding: (320: 0 0 rem(10), 768: rem(21) 0 rem(35))))
          &:after
            content: ""
            position: absolute
            left: 0
            bottom: 0
            height: rem(4)
            width: 0
            background: $red
            transition: .5s
        &:hover
          color: $black
          .name
            &:after
              width: 50%
        &.active
          color: $black
          .name
            &:after
              width: 100%
        input[type="radio"]
          position: absolute
          left: 0
          top: 0
          height: 0
          width: 0
          display: none
          opacity: 0
          pointer-events: none
    &__materials
      display: grid
      grid-column-gap: rem(1)
      grid-row-gap: rem(1)
      width: 100%
      +media((padding: (320: rem(32) rem(24) 0, 992: 0)))
      +media((grid-template-columns: (320: repeat(2, 1fr), 576: repeat(3, 1fr),
      768: repeat(4, 1fr))))
      &-item
        background: #ffffff
        position: relative
        &.shadow
          box-shadow: 0 0 0 rem(0.5) #ECECEC
        &:hover, &.active
          .dampCourse__materials-item--img
            &:after
              opacity: 1
          .dampCourse__materials-item--name
            color: $red
        &--label
          +media((padding: (320: rem(8) rem(13) rem(10), 992: rem(17) rem(20) rem(22))))
          cursor: pointer
          display: flex
          flex-direction: column
          position: relative
        &--img
          line-height: 0
          position: relative
          &:after
            +media((background-image: (320: url(../assets/img/tick-mini.svg),
            768: url(../assets/img/tick.svg))))
            background-repeat: no-repeat
            top: 0
            bottom: 0
            left: 0
            right: 0
            content: ""
            position: absolute
            width: 100%
            height: 100%
            background-position: center
            line-height: 0
            opacity: 0
            pointer-events: none
            transition: .5s
            display: flex
            flex-direction: row
            justify-content: center
            align-items: center
          img
            max-width: 100%
            width: auto
            +media((height: (320: rem(110), 992: rem(120))))
            object-fit: cover
        &--name
          font-style: normal
          font-weight: 600
          line-height: rem(21)
          color: $black
          text-align: left
          width: 100%
          display: flex
          flex-direction: row
          align-items: center
          justify-content: space-between
          +media((font-size: (320: rem(13), 992: rem(14))))
          +media((padding-top: (320: rem(16), 992: rem(21))))
          .showInfo
            &-btn
              line-height: 0
              cursor: help
              padding-left: rem(20)
              +media((position: (320: absolute, 992: relative)))
              +media((right: (320: rem(15), 992: unset)))
              +media((top: (320: rem(10), 992: unset)))
              svg
                .circle
                  transition: .5s
                  +media((opacity: (320: .3, 992: .8)))
                  +media((fill: (320: $red, 992: #D6D6D6)))
        .info
          background: #FFFFFF
          box-shadow: 0 rem(4) rem(14) rgba(0, 0, 0, 0.16)
          border-radius: rem(4)
          +media((padding: (320: rem(17) rem(20), 992: rem(20) rem(20) rem(14))))
          display: flex
          flex-direction: column
          align-items: flex-start
          &__overlay
            z-index: 3
            +media((position: (320: fixed, 900: absolute)))
            +media((min-height: (320: 100vh, 900: 100%)))
            display: flex
            flex-direction: row
            justify-content: center
            align-items: center
            width: 100%
            top: 0
            left: 0
            transition: .5s
            +media((background: (320: rgba(0, 0, 0, 0.3), 900: transparent)))
            .info
              +media((min-height: (320: unset, 992: 100%)))
              +media((width: (320: rem(240), 992: 100%)))
              position: relative
          &__title
            font-style: normal
            font-weight: 600
            font-size: rem(14)
            line-height: rem(21)
            text-align: left
            padding-right: rem(40)
          &__text
            text-align: left
            font-style: normal
            font-weight: 500
            font-size: rem(12)
            line-height: rem(20)
            color: #5C5C5C
            padding-top: rem(14)
            &-roll
              b
                padding-right: rem(16)
                position: relative
                &.divider
                  &:after
                    content: "|"
                    color: #D6D6D6
                    position: absolute
                    right: rem(8)
          .close
            background: none
            box-shadow: none
            border: none
            position: absolute
            right: 0
            top: 0
            line-height: 0
            cursor: pointer
            outline: none
            +media((padding: (320: rem(17), 992: rem(18))))
      input[type="radio"]
        position: absolute
        left: 0
        top: 0
        height: 0
        width: 0
        display: none
        opacity: 0
        pointer-events: none
</style>
